import React, { useState } from "react";
import PropTypes from "prop-types";
import QuizAnswerChoice from "./QuizAnswerChoice";
import { QUIZ_ANSWER_STATES } from "../constants";

const propTypes = {
  answerOptions: PropTypes.arrayOf(
    PropTypes.shape({
      answerLetter: PropTypes.string.isRequired,
      answerText: PropTypes.string.isRequired,
      link: PropTypes.string,
      state: PropTypes.oneOf(Object.values(QUIZ_ANSWER_STATES))
    })
  ).isRequired,
  isAnonUser: PropTypes.bool.isRequired,
  locked: PropTypes.bool.isRequired,
  onAnswerSelect: PropTypes.func.isRequired,
  questionId: PropTypes.number.isRequired,
  questionIndex: PropTypes.number.isRequired,
  questionText: PropTypes.string.isRequired,
  questionTotal: PropTypes.number.isRequired
};

function QuizCard({
  answerOptions,
  locked,
  isAnonUser,
  onAnswerSelect,
  questionId,
  questionIndex,
  questionText,
  questionTotal
}) {
  const [selectedAnswer, setSelectedAnswer] = useState();

  const handleAnswerSelect = (answerLetter) => {
    if (!locked) {
      setSelectedAnswer(answerLetter);
    }

    onAnswerSelect(answerLetter);
  };

  return (
    <div className="quiz-card" data-testid={`QuizCard-${questionId}`}>
      <div className="quiz-question">
        <h5
          className="title-5"
          dangerouslySetInnerHTML={{ __html: questionText }}
        />
        <div>
          <span className="question-range">
            {questionIndex} of {questionTotal}
          </span>
        </div>
      </div>
      <div className="answer-columns">
        {answerOptions.map((answerOption) => {
          return (
            <div key={answerOption.answerLetter} className="answer-column">
              <QuizAnswerChoice
                isAnonUser={isAnonUser}
                answerLetter={answerOption.answerLetter}
                answerText={answerOption.answerText}
                isSelectedAnswer={selectedAnswer === answerOption.answerLetter}
                setSelectedAnswer={handleAnswerSelect}
                state={locked ? QUIZ_ANSWER_STATES.LOCKED : answerOption.state}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
}

QuizCard.propTypes = propTypes;

export default QuizCard;
